module.exports = "/cyber/_next/static/images/itogiNG-e82914b917d10da4e3eeaef095a3daee.jpg";